export default {
  name: 'addMaintenance',
  data() {
    return {
      sysData: [],
      supLevelList: [],
      industryData: [],
      provinceData: [],
      cityData: [],
      areaData: [],
      tabDisabled: true,
      tabFirstDisabled: false,
      off: 'off',
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      totalRows: 100,
      /* 付款类型 */
      paymentType: [
        {
          id: 0,
          value: '月结'
        }
      ],
      /* 账户状态 */
      supAccountStateData: [
        {
          id: 1,
          value: '有效'
        },
        {
          id: 0,
          value: '无效'
        }
      ],
      abuNameData: [],
      activeName: 'first',
      infoEssential: {
        sysId: '',
        supName: '',
        supId: '',
        supShortName: '',
        paymentType: '',
        state: 1,
        ipaddress: ''
      },
      infoContacts: {
        contacts: '',
        conPhone: '',
        conMail: '',
        sex: '1',
        post: '',
        date: ''
      },
      /* 整体form */
      editMaintenance: {
        sysId: '',
        supName: '',
        supContactsId: '',
        supShortName: '',
        paymentType: '',
        state: 1,
        ipaddress: '',
        contacts: '',
        conPhone: '',
        conMail: '',
        abuName: '',
        abuMobile: '',
        contractEffectiveDate: '',
        industry: '',
        qualification: '',
        gradeCode: '',
        province: '',
        city: '',
        area: '',
        detailInfo: '',
        intro: '',
        /* 账户信息 */
        supAccountData: [
          {
            supAccountId: '',
            supAccountName: '',
            supAccountPwd: '',
            apikey: '',
            state: '',
            supId: ''
          }
        ],
        /* 合同附近 */
        contractFiles: [
          // {
          //   name: '',
          //   url: ''
          // }
          /* {
            contractFileUrl: '',
            contractFileName: ''
          } */
        ],
        /* 扩展属性 */
        extFieldList: [
          {
            name: '',
            value: ''
          }
        ]
      },
      /* 存储删除的账户信息 */
      supAccountData2: [],
      /* 存储删除的扩展信息 */
      extFieldList2: [],
      abuMobileBoolean: true, // 商务经理电话可输入状态
      rules: {
        supAccountName: [
          {
            required: true,
            message: '请输入活动名称',
            trigger: ['blur', 'change']
          }
        ],
        sysId: [
          {
            required: true,
            message: '请选择业务系统',
            trigger: ['blur', 'change']
          }
        ],
        supName: [
          {
            required: true,
            message: '请输入供应商全称',
            trigger: ['blur', 'change']
          }
        ],
        supShortName: [
          {
            required: true,
            message: '请输入供应商简称',
            trigger: ['blur', 'change']
          }
        ],
        contacts: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: ['blur', 'change']
          }
        ],
        conPhone: [
          {
            required: true,
            message: '请输入联系人号码',
            trigger: ['blur', 'change']
          },
          { validator: this.regular.phone, trigger: ['blur', 'change'] }
        ],
        conBusMail: [
          {
            message: '请输入商务经理邮箱',
            trigger: ['blur', 'change']
          },
          { validator: this.regular.email, trigger: ['blur', 'change'] }
        ],
        conMail: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: ['blur', 'change']
          },
          { validator: this.regular.email, trigger: ['blur', 'change'] }
        ]
      },
      uploadFile: this.$API.fileUpload,
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      num: '',
      size: '',
      dialogTitle: {
        addMaintenance: '新增供应商档案',
        editMaintenance: '编辑供应商档案'
      },
      dialogStatus: ''
    }
  },
  mounted () {
    this.queryDefaultList()
    /* 查询地理位置 */
    let _this = this
    this.$http({
      method: 'get',
      url: _this.$API.supplier.queryAddrCode
    }).then((response) => {
      let data = response.data.resData
      _this.provinceData = data
      console.log(_this.provinceData)
    }).catch((error) => {
      console.log(error)
    })
    this.dialogStatus = 'addMaintenance'
    /* 若是编辑页查询详情信息 */
    if (this.$route.query.supId) {
      this.dialogStatus = 'editMaintenance'
      this.queryEditDetail(this.$route.query.supId)
    }
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
  },
  methods: {
    queryDefaultList() {
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size
      }
      let _self = this
      let _this = this
      /* 查询所属系统列表 */
      this.$axios
        .post(this.$API.apiList.querySysList, params)
        .then(function(r) {
          _self.sysData = r.data.resData
        })
        .catch(function(error) {})
      /* 查询商务经理列表 */
      let type = {abuType: 1}
      this.$axios
        .get(this.$API.supplier.queryBusinessMangerList, {params: type})
        .then(function(r) {
          _self.abuNameData = r.data.resData.userList
        })
        .catch(function(error) {})
        /* 查询供应商等级 */
      this.$http({
        method: 'get',
        url: _this.$API.supplier.queryGradeCode
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        this.supLevelList = data.gradeInfos
      }).catch((error) => {
        console.log(error)
      })
      /* 查询供应商行业 */
      this.$http({
        method: 'get',
        url: _this.$API.supplier.queryIndustryCode
      }).then((response) => {
        console.log(response.data)
        let data = response.data.resData
        _self.industryData = data.industryInfos
      }).catch((error) => {
        console.log(error)
      })
    },
    provinceChange (val) {
      console.log(val)
      console.log(this.provinceData)
      this.editMaintenance.city = ''
      this.editMaintenance.area = ''
      if (val && val !== 0) {
        for (let v of this.provinceData) {
          if (v.short_code === val) {
            console.log(v)
            this.cityData = v.city
          }
        }
      } else {
        this.cityData = []
        this.areaData = []
      }
      console.log(this.cityData)
    },
    cityChange (val) {
      console.log(val)
      console.log(this.cityData)
      this.editMaintenance.area = ''
      if (val && val !== 0) {
        for (let v of this.cityData) {
          if (v.short_code === val) {
            this.areaData = v.area
          }
        }
      } else {
        this.areaData = []
      }
    },
    /* 查询详情信息 */
    queryEditDetail(supId) {
      let params = {
        supId: supId
      }
      let _self = this
      this.$axios
        .post(this.$API.supplier.querySupInfoBySupId, params)
        .then(function(r) {
          let data = r.data.resData
          _self.editMaintenance = {
            sysId: data.sysId,
            supName: data.supName,
            supShortName: data.supShortName,
            paymentType: data.paymentType,
            state: data.state,
            ipaddress: data.ipaddress,
            contacts: data.supContacts.contacts, // 联系人
            conPhone: data.supContacts.conPhone,
            conMail: data.supContacts.conMail,
            supContactsId: data.supContacts.supContactsId,
            abuName: data.supAbu.abuName, // 商务信息
            abuMobile: data.supAbu.abuMobile,
            /* 合同日期 */
            contractEffectiveDate: [],
            /* 账户信息form */
            supAccountData: data.supAccounts ? data.supAccounts : [],
            /* 合同附件form */
            contractFiles: [],
            /* 扩展属性form */
            extFieldList: data.extFieldList
          }
          if (data.contractEffectiveDate && data.contractExpirationDate) {
            _self.editMaintenance.contractEffectiveDate = [data.contractEffectiveDate,data.contractExpirationDate] 
          } else {
            _self.editMaintenance.contractEffectiveDate = []
          }
          if (data.contractFiles.length) {
            for (let v of data.contractFiles) {
              let op = {}
              op.name = v.contractFileName
              op.url = v.contractFileUrl
              _self.editMaintenance.contractFiles.push(op)
            }
          }
          console.log(_self.editMaintenance.contractFiles)
          if (data.supAbu.abuName) {
            _self.abuMobileBoolean = false
          }
        })
        .catch(function(error) {})
    },
    handlePictureCardPreview() {},
    /* 选择商务经理联动商务经理电话 */
    changeTemplate(data) {
      this.abuMobileBoolean = false
      this.editMaintenance.abuMobile = data.mobile
      this.editMaintenance.conBusMail = data.email
    },
    /* 如果商务经理没有选中清空商务经理电话 */
    clearAbuNameSel(data) {
      this.abuMobileBoolean = true
      data === '' ? (this.editMaintenance.abuMobile = '') : ''
    },
    /* 添加账户 */
    addSupAccount() {
      this.editMaintenance.supAccountData.push({
        supAccountId: '',
        supAccountName: '',
        supAccountPwd: '',
        apikey: '',
        state: '',
        supId: ''
      })
    },
    /* 删除账户 */
    removeSupAccount(item) {
      var index = this.editMaintenance.supAccountData.indexOf(item)
      if (index !== -1) {
        /* 对已存在的账户删除push到另一个数组 */
        if (item.supAccountId) {
          item.isDelete = 1
          this.supAccountData2.push(item)
        }
        this.editMaintenance.supAccountData.splice(index, 1)
      }
    },
    /* 添加扩展属性 */
    addExtField() {
      this.editMaintenance.extFieldList.push({
        name: '',
        value: ''
      })
    },
    /* 删除扩展属性 */
    removeExtField(item) {
      var index = this.editMaintenance.extFieldList.indexOf(item)
      if (index !== -1) {
        /* 对已存在的扩展属性删除push到另一个数组 */
        /* if (item.id) {
          item.isDelete = 1
          this.extFieldList2.push(item)
        } */
        this.editMaintenance.extFieldList.splice(index, 1)
      }
    },
    /* 扩展属性根据id去重 */
    removeRepeatArr(data) {
      let map = {}
      let newObj = []
      data.map(function(val) {
        map[val.id] = val
      })
      for (var key in map) {
        newObj.push(map[key])
      }
      return newObj
    },
    success(response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        console.log(response.resData)
        let op = {}
        op.name = response.resData.fileName
        op.url = response.resData.url
        this.editMaintenance.contractFiles.push(op)
      }
    },
    handleRemove(file, fileList) {
      // 删除图片
      let url = file.url
      for (let i = 0; i < this.editMaintenance.contractFiles.length; i++) {
        if (this.editMaintenance.contractFiles[i].url === url) {
          this.editMaintenance.contractFiles.splice(i, 1)
        }
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview(file) {
      /* 预览 TODO */
      console.log(file)
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(
        file.url,
        '_blank',
        'width=' +
          _width +
          ', height = ' +
          _height +
          ', menubar = no,toolbar = no, status = no, scrollbars = yes'
      )
      // const userAgent = navigator.userAgent
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   alert('推荐谷歌进行文件预览')
      // } else {
      //   window.open(file.url) // blob格式地址
      // }
    },
    /* 上传前校验大小限制 */
    beforeAvatarUpload(file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 20
      /* if(!extension) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        });
      } */
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      return extension && isLt2M
    },
    /* 返回列表 */
    returnList() {
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        path: '/maintenance',
        query: {
          num: this.num,
          size: this.size
        }
      })
    },
    saveEssential (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          let id = _this.infoEssential.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          // op.supId = _this.infoEssential.supId
          op.sysIds = sysIds
          op.supName = _this.infoEssential.supName
          op.supShortName = _this.infoEssential.supShortName
          op.paymentType = _this.infoEssential.paymentType
          op.state = _this.infoEssential.state
          op.ipaddress = _this.infoEssential.ipaddress
          _this.$axios
            .post(_this.$API.supplier.addSupInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增基本信息成功'
              })
              console.log(r)
              _this.tabDisabled = false
              _this.activeName = 'second'
              _this.tabFirstDisabled = true
              _this.infoEssential.supId = r.data.resData.supId
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveContacts (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.supId = _this.infoEssential.supId
          op.contactName = _this.infoContacts.contacts
          op.contactTel = _this.infoContacts.conPhone
          op.contactMail = _this.infoContacts.conMail
          op.sex = _this.infoContacts.sex
          op.contactPosition = _this.infoContacts.post
          op.birthday = _this.infoContacts.date
          if (!op.supId) {
            _this.$message.error('请先保存基本信息!')
            return
          }
          _this.$axios
            .post(_this.$API.supplier.addSupContacts, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupContacts', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增联系人信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveBusinessAccount (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.supId = _this.infoEssential.supId
          op.accList = _this.editMaintenance.supAccountData
          console.log(_this.editMaintenance.supAccountData)
          if (!op.supId) {
            _this.$message.error('请先保存基本信息!')
            return
          }
          _this.$axios
            .post(_this.$API.supplier.updateSupAllAccount, op)
            // .post('http://172.16.6.77:5010/agw/supAccountCtr/updateSupAllAccount', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增业务账户信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveDetail (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.supId = _this.infoEssential.supId
          op.gradeCode = _this.editMaintenance.gradeCode
          op.qualificationCode = _this.editMaintenance.qualification
          op.industryCode = _this.editMaintenance.industry
          op.addrDetail = _this.editMaintenance.detailInfo
          op.desc = _this.editMaintenance.intro
          console.log(_this.editMaintenance.province)
          console.log(_this.editMaintenance.city)
          console.log(_this.editMaintenance.area)
          if (_this.editMaintenance.province) {
            if (!_this.editMaintenance.city || !_this.editMaintenance.area) {
              _this.$message.error('地理位置请选择省市区!')
              return
            }
            op.addrCode = _this.editMaintenance.province + '-' + _this.editMaintenance.city + '-' + _this.editMaintenance.area
          } else {
            op.addrCode = ''
          }
          if (!op.supId) {
            _this.$message.error('请先保存基本信息!')
            return
          }
          _this.$axios
            .post(_this.$API.supplier.addSupDetailInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupDetailInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增详细信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveBusiness (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.supId = _this.infoEssential.supId
          op.abuId = _this.editMaintenance.abuName
          // op.abuId = _this.editMaintenance.supAccountData
          if (!op.supId) {
            _this.$message.error('请先保存基本信息!')
            return
          }
          _this.$axios
            .post(_this.$API.supplier.addSupAbuInfo, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupAbuInfo', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增商务信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveExtended (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.supId = _this.infoEssential.supId
          op.extFieldList = _this.editMaintenance.extFieldList
          if (!op.supId) {
            _this.$message.error('请先保存基本信息!')
            return
          }
          _this.$axios
            .post(_this.$API.supplier.addSupExtFieldList, op)
            // .post('http://172.16.6.77:5010/agw/supInfoCtrV2/addSupExtFieldList', op)
            .then(function(r) {
              _this.$message({
                type: 'success',
                message: '新增扩展信息成功'
              })
            })
            .catch(function(error) {})
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    /* 保存供应商档案信息 */
    saveAddMaintenance(formName) {
      /* 判断弹窗状态值, 编辑修改/新增保存 */
      if (this.dialogStatus == 'editMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            for (let v of this.editMaintenance.supAccountData) {
              if (v.isDelete === '') {
                v.isDelete = 0
              }
            }
            let params = {
              contractEffectiveDate: this.editMaintenance.contractEffectiveDate
                ? this.editMaintenance.contractEffectiveDate[0]
                : '',
              contractExpirationDate: this.editMaintenance.contractEffectiveDate
                ? this.editMaintenance.contractEffectiveDate[1]
                : '',
              contractFiles: [], // 合同附件 TODO
              createTime: '',
              ipaddress: this.editMaintenance.ipaddress.trim(),
              paymentType: this.editMaintenance.paymentType,
              state: this.editMaintenance.state,
              // 联系人信息
              supContacts: {
                conMail: this.editMaintenance.conMail.trim(),
                conPhone: this.editMaintenance.conPhone,
                conPosition: '',
                contacts: this.editMaintenance.contacts.trim(),
                supContactsId: this.editMaintenance.supContactsId,
                supId: ''
              },
              // 商务信息
              // supAbu: {
              //   abuDept: '',
              //   abuId: '',
              //   abuMail: '',
              //   abuMobile: this.editMaintenance.abuMobile.trim(),
              //   abuName: this.editMaintenance.abuName.trim(),
              //   abuPos: '',
              //   supId: ''
              // },
              supAbuId: this.editMaintenance.abuName.trim(),
              // 扩展属性
              extFieldList: this.editMaintenance.extFieldList,
              // 账户信息
              supAccounts: this.editMaintenance.supAccountData.concat(
                this.supAccountData2
              ),
              supName: this.editMaintenance.supName.trim(),
              supShortName: this.editMaintenance.supShortName.trim(),
              supId: this.$route.query.supId,
              sysId: this.editMaintenance.sysId
            }
            for (let v of this.editMaintenance.contractFiles) {
              let op = {}
              op.contractFileName = v.name
              op.contractFileUrl = v.url
              params.contractFiles.push(op)
            }

            let ipRule = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
              regVal = false,
              ipaddressVal = params.ipaddress
            /* 判断ip地址最后以为是否有";",有就去掉以便验证 */
            if (ipaddressVal.substr(ipaddressVal.length - 1, 1) == ';') {
              ipaddressVal = ipaddressVal.substring(0, ipaddressVal.length - 1)
            } else {
              ipaddressVal = ipaddressVal
            }
            let ipArry = ipaddressVal.split(';'),
              newIpArry = ipArry.sort(),
              ipSortBlooen = false
            /* 判断ip是否有值,有校验无跳过 */
            if (params.ipaddress.length) {
              ipArry.forEach(function(v) {
                if (v.match(ipRule) == null) {
                  regVal = true
                  return false
                }
              })
            } else {
              regVal = false
            }
            /* 对数组进行排序，查上一个和下一个是否相等 */
            for (let i = 0; i < ipArry.length; i++) {
              if (newIpArry[i] == newIpArry[i + 1]) {
                ipSortBlooen = true
              }
            }
            // 校验ip地址列表是否重复
            if ((params.ipaddress && !ipSortBlooen) || !params.ipaddress) {
              this.$axios
                .post(this.$API.supplier.updateSupInfoBySupId, params)
                .then(function(r) {
                  _self.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  _self.$store.commit('closeTab', _self.$route) // 关闭当前路由
                  _self.$router.push({
                    path: '/maintenance'
                  })

                })
                .catch(function(error) {})
            } else {
              this.$message({
                type: 'warning',
                message: 'IP输入重复，请修改后保存'
              })
            }
          }
        })
      } else if (this.dialogStatus == 'addMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let params = {
              contractEffectiveDate: this.editMaintenance.contractEffectiveDate
                ? this.editMaintenance.contractEffectiveDate[0]
                : '',
              contractExpirationDate: this.editMaintenance.contractEffectiveDate
                ? this.editMaintenance.contractEffectiveDate[1]
                : '',
              contractFiles: [], // 合同附件 TODO
              createTime: '',
              ipaddress: this.editMaintenance.ipaddress.trim(),
              paymentType: this.editMaintenance.paymentType,
              state: this.editMaintenance.state,
              // 联系人信息
              supContacts: {
                conMail: this.editMaintenance.conMail.trim(),
                conPhone: this.editMaintenance.conPhone,
                conPosition: '',
                contacts: this.editMaintenance.contacts.trim(),
                supContactsId: '',
                supId: ''
              },
              // 商务信息
              // supAbu: {
              //   abuDept: '',
              //   abuId: '',
              //   abuMail: '',
              //   abuMobile: this.editMaintenance.abuMobile.trim(),
              //   abuName: this.editMaintenance.abuName.trim(),
              //   abuPos: '',
              //   supId: ''
              // },
              supAbuId: this.editMaintenance.abuName.trim(),
              // 扩展属性
              extFieldList: this.editMaintenance.extFieldList,
              // 账户信息
              supAccounts: this.editMaintenance.supAccountData,
              supName: this.editMaintenance.supName.trim(),
              supShortName: this.editMaintenance.supShortName.trim(),
              sysId: this.editMaintenance.sysId
            }
            for (let v of this.editMaintenance.contractFiles) {
              let op = {}
              op.contractFileName = v.name
              op.contractFileUrl = v.url
              params.contractFiles.push(op)
            }

            let ipRule = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/,
              regVal = false,
              ipaddressVal = params.ipaddress
            /* 判断ip地址最后以为是否有";",有就去掉以便验证 */
            if (ipaddressVal.substr(ipaddressVal.length - 1, 1) == ';') {
              ipaddressVal = ipaddressVal.substring(0, ipaddressVal.length - 1)
            } else {
              ipaddressVal = ipaddressVal
            }
            let ipArry = ipaddressVal.split(';'),
              newIpArry = ipArry.sort(),
              ipSortBlooen = false
            /* 判断ip是否有值,有校验无跳过 */
            if (params.ipaddress.length) {
              ipArry.forEach(function(v) {
                if (v.match(ipRule) == null) {
                  regVal = true
                  return false
                }
              })
            } else {
              regVal = false
            }
            /* 对数组进行排序，查上一个和下一个是否相等 */
            for (let i = 0; i < ipArry.length; i++) {
              if (newIpArry[i] == newIpArry[i + 1]) {
                ipSortBlooen = true
              }
            }

            // 校验ip地址列表是否重复
            if ((params.ipaddress && !ipSortBlooen) || !params.ipaddress) {
              this.$axios
                .post(this.$API.supplier.addNewSupInfo, params)
                .then(function(r) {
                  _self.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  _self.$store.commit('closeTab', _self.$route) // 关闭当前路由
                  _self.$router.push({
                    path: '/maintenance'
                  })
                })
                .catch(function(error) {})
            } else {
              this.$message({
                type: 'warning',
                message: 'IP输入重复，请修改后保存'
              })
            }
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/supper/editMaintenance.js